function getBooksCompleted(completedBooks, age) {
  return Array
    .from(completedBooks)
    .map(bk => bk[1])
    .filter(bk => bk.age === age)
}

export default getBooksCompleted
